import { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Dialog, useTheme } from '@mui/material'
import GroupCourseGradebookFilters from 'components/organisms/forms/tableFilters/gradebook/GroupCourseGradebookFilters'
import GroupCourseGradeFinalForm from 'components/organisms/forms/GroupCourseGradeFinalForm'
import { AppDispatch, RootState } from 'redux/store'
import { setAcademicYear, setGradeLevel, setGradePopupData, setGroup, setGroupCourse, setStudent, setSummary } from 'redux/ui/groupCourseGradebookUI'
import { useGET_gradebookGridQuery, useGET_gradebookGridSummaryQuery } from 'redux/api/gradebookApi'
import GroupCourseGradebookSummary from './GroupCourseGradebookSummary'
import GroupCourseGradebookFull from './GroupCourseGradebookFull'

interface IProps {
  groupCourse: any
  viewOnly?: boolean
  tabText?: string
  tabKey?: string
}

const GroupCourseGradebook: FC<IProps> = ({ groupCourse, viewOnly=false }) => {
  const dispatch = useDispatch<AppDispatch>()

  const theme = useTheme()

  const reduxKey = 'groupCourseGradebook';

  const grade_popup_data = useSelector((state: RootState) => state[reduxKey].grade_popup_data)
  const academic_year =  useSelector((state: RootState) => state[reduxKey].tableFilters.academic_year)
  const grade_level =  useSelector((state: RootState) => state[reduxKey].tableFilters.grade_level)
  const group =  useSelector((state: RootState) => state[reduxKey].tableFilters.group)
  const group_course =  useSelector((state: RootState) => state[reduxKey].tableFilters.group_course)
  const student = useSelector((state: RootState) => state[reduxKey].tableFilters.student)
  const summary = useSelector((state: RootState) => state[reduxKey].tableFilters.summary)

  const selectedGroupCourse = groupCourse?.id || group_course
  const selectedGradeLevel = groupCourse?.course?.grade_level || grade_level
 
  let filtersGradebookGrid = {
    student_id: student || '',
  }

  const { data: gradebookGrid } = useGET_gradebookGridQuery({
      group_course: selectedGroupCourse, 
      params: filtersGradebookGrid
  }, {skip: !selectedGroupCourse || summary})


  let filtersGradebookGridSummary = {
    group_id: group || '',
    student_id: student || '',
  }
  const { data: gradebookGridSummary } = useGET_gradebookGridSummaryQuery({
    academic_year: academic_year, 
    grade_level: selectedGradeLevel,
    params: filtersGradebookGridSummary
  }, {skip: !academic_year || selectedGradeLevel == null || !summary})


  useEffect(() => {
    dispatch(setSummary(false))
    dispatch(setAcademicYear(null))
    dispatch(setGradeLevel(null))
    dispatch(setGroup(null))
    dispatch(setGroupCourse(null))
    dispatch(setStudent(null))
   
  }, [])


  return (
    <>
      <GroupCourseGradebookFilters groupCourse={groupCourse} />  

      {
        summary && gradebookGridSummary && selectedGradeLevel != null &&
          <GroupCourseGradebookSummary 
            groupCourse={groupCourse}
            courses={gradebookGridSummary.courses} 
            students={gradebookGridSummary.students} 
          />
      }

      {!summary && gradebookGrid && selectedGroupCourse && 
        <GroupCourseGradebookFull
            groupCourse={groupCourse}
            courses={gradebookGrid.courses} 
            students={gradebookGrid.students} 
            academic_periods={gradebookGrid.academic_periods}
            components={gradebookGrid.components}
            />
      }

      { grade_popup_data && 
      <Dialog
        onClose={() => dispatch(setGradePopupData(null))}
        open={!!grade_popup_data}
        fullWidth
        maxWidth='md'
        PaperProps={{
          sx: {
            margin: 0,
            padding: '2rem',
            width: { xs: '100vw', md: '800px' },
            maxWidth: { xs: '100vw', md: '80vw' },
            background: theme.palette.background.default,
          },
        }}
       >
        <GroupCourseGradeFinalForm gradePopupData={grade_popup_data}  />  
      </Dialog>
       }

    </>
  )
}
export default GroupCourseGradebook

